import { CartService } from "./implementations/cart.service";

export default defineNuxtPlugin((nuxtApp) => {
  const cart = new CartService();

  return {
    provide: {
        cart: cart,
    },
  };
});